import { Component, ViewEncapsulation } from "@angular/core";
import { ArcusAuthService } from "./core/arcusauth.service";
import { MatIconRegistry } from "@angular/material/icon";

@Component({
    selector: "app-root",
    templateUrl: "./app-root.html",
    encapsulation: ViewEncapsulation.None,
    styleUrls: ["./app-root.scss"],
    standalone: false,
})
export class AppRootComponent {
    constructor(
        private authService: ArcusAuthService,
        private matIconRegistry: MatIconRegistry
    ) {
        this.matIconRegistry.setDefaultFontSetClass("material-symbols-outlined");
    }
}
